import * as React from "react"
import * as FontAwesome from "react-fontawesome"
import ISystemStatusVm from "../../models/home/Home/ISystemStatusVm"
import { SystemStatusSeverityType } from "../../models/enums/SystemStatusSeverityType"

interface IProps {
    systemStatus: ISystemStatusVm
}

export default function SystemStatusComponent({ systemStatus }: IProps) {
    const getSeverityColor = () => {
        switch (systemStatus.systemStatusSeverity) {
            case SystemStatusSeverityType.Normal:
                return "#28a745" // Green
            case SystemStatusSeverityType.Warning:
                return "#ffc107" // Yellow
            case SystemStatusSeverityType.Error:
                return "#dc3545" // Red
            default:
                return "#6c757d" // Grey
        }
    }

    return (
        <React.Fragment>
            <h2>
                <FontAwesome name="circle" style={{ color: getSeverityColor() }} />&nbsp;{systemStatus.title}
            </h2>
            <div>
                {!!systemStatus.description &&
                    <p>{systemStatus.description}</p>
                }
            </div>
        </React.Fragment>
    )
}